import React, { createContext, useReducer } from 'react';
import { ProvisioningReducer, initialProvisioningState } from "../reducer/ProvisioningReducer";

export const ProvisioningContext = createContext();

const ProvisioningContextProvider = (props) => {
    const [provisioningViewModel, provisioningDispatch] = useReducer(ProvisioningReducer, initialProvisioningState);
    
    return (
        <ProvisioningContext.Provider value={{ provisioningViewModel, provisioningDispatch }}>
            {props.children}
        </ProvisioningContext.Provider>
    );
};

export default ProvisioningContextProvider;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/context/ProvisioningContext.js